import React from "react";

import { Stack } from "@mui/material";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "../../TransitionsDetails.module.css";

interface DetailsSectionData {
  label: string;
  value: React.ReactNode;
}

interface DetailsSectionProps {
  title: string;
  data: DetailsSectionData[];
  titleVariant?: "title1" | "title2";
}

const DetailsSection: React.FC<DetailsSectionProps> = ({
  title,
  data,
  titleVariant = "title2",
}) => {
  return (
    <div style={{ marginTop: "24px" }}>
      <Stack className={styles.tabularContainer}>
        <Text variant={titleVariant} className={styles.tabularTitle}>
          {title}
        </Text>
        <Stack className={styles.tabularContent}>
          {data.map(({ label, value }) => (
            <div key={label} className={styles.tabularRow}>
              <Text
                variant="body"
                className={toClassName(styles.tabularEntry, styles.leftEntry)}
              >
                {label}
              </Text>
              {React.isValidElement(value) ? (
                value
              ) : (
                <Text
                  variant="body"
                  className={toClassName(
                    styles.tabularEntry,
                    styles.rightEntry
                  )}
                >
                  {value}
                </Text>
              )}
            </div>
          ))}
        </Stack>
      </Stack>
    </div>
  );
};

export default DetailsSection;
